import DocumentTitle from "react-document-title";

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

export function AlreadyPayed(){
    return(
        <DocumentTitle title='Adamo'>
            <Container className="justify-content-md-center p-2 bg-light border">
                <Image src="images/adamo_logo.png" rounded></Image> <br/> <br/>
                <p className="text-start">Ez az Adamo példány már ki van fizetve.</p>
                <br/>
                <p className="text-end fw-bold">Az Adamo csapata</p>
            </Container>
        </DocumentTitle>
    )
}
